import CurrentTime from "./CurrentTime";

export default CurrentTime;
